import React, { useContext, useEffect, Fragment } from "react";
import { Segment, Grid } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";

const General = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    invoice,
  } = rootStore.invoiceStore;
  const { getRejectionConcepts } = rootStore.listOfValours;

  useEffect(() => {
    getRejectionConcepts();
  }, [getRejectionConcepts]);

  if (invoice === null) {
    return <LoadingComponent content="Cargando" />;
  }
  return (
    <div>
      <Segment className="grayborder">
        <Grid textAlign="center">
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Factura No. </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{invoice.erpDocumentId}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Documento DIAN No. </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{invoice.docId}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Fecha Documento </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{invoice.issueDate}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Fecha de recepción </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{invoice.receptionDate}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>A nombre de </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{invoice.acquirerName}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Identificación </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{invoice.acquirerIdentification}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>CUFE </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{invoice.cufe}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Por valor de </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>
                {invoice.documentValue} {invoice.documentCurrencyCode}
              </strong>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </div>
  );
};

export default observer(General);
